import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const MainLayout = () => import('@/layouts/MainLayout.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/public/shipments',
    name: 'PublicShipmentQuery',
    component: () => import('@/views/PublicShipmentQuery.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/mp-print/accompanying/:id',
    name: 'MpAccompanyingPrint',
    component: () => import('@/views/mp/MpAccompanyingPrint.vue'),
    meta: { requiresAuth: false, mpPrint: true }
  },
  {
    path: '/mp-print/certificate/:id/batch',
    name: 'MpCertificateBatchPrint',
    component: () => import('@/views/mp/MpCertificateBatchPrint.vue'),
    meta: { requiresAuth: false, mpPrint: true }
  },
  {
    path: '/',
    name: 'SiteHome',
    component: () => import('@/views/SiteHome.vue'),
    meta: { requiresAuth: false, siteHome: true }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: 'projects',
        name: 'ProjectManagement',
        component: () => import('@/views/ProjectManagement.vue')
      },
      {
        path: 'shipments-all',
        name: 'ShipmentManagementAll',
        component: () => import('@/views/ShipmentManagementAll.vue')
      },
      {
        path: 'shipment-costs',
        name: 'ShipmentCostManagement',
        component: () => import('@/views/ShipmentCostManagement.vue')
      },
      {
        path: 'products',
        name: 'ProductManagement',
        component: () => import('@/views/ProductManagement.vue')
      },
      {
        path: 'customs-companies',
        name: 'CustomsCompanyManagement',
        component: () => import('@/views/CustomsCompanyManagement.vue')
      },
      {
        path: 'certificates',
        name: 'CertificateManagement',
        component: () => import('@/views/CertificateManagement.vue')
      },
      {
        path: 'packing-factories',
        name: 'PackingFactoryManagement',
        component: () => import('@/views/PackingFactoryManagement.vue')
      },
      {
        path: 'orchards',
        name: 'OrchardManagement',
        component: () => import('@/views/OrchardManagement.vue')
      },
      {
        path: 'signatures',
        name: 'SignatureManagement',
        component: () => import('@/views/SignatureManagement.vue')
      },
      {
        path: 'app-profiles',
        name: 'AppProfileManagement',
        component: () => import('@/views/AppProfileManagement.vue')
      },
      {
        path: 'wechat-pay-config',
        name: 'WechatPayConfig',
        component: () => import('@/views/WechatPayConfig.vue')
      },
      {
        path: 'catalog-categories',
        name: 'CatalogCategoryManagement',
        component: () => import('@/views/CatalogCategoryManagement.vue')
      },
      {
        path: 'catalog-products',
        name: 'CatalogProductManagement',
        component: () => import('@/views/CatalogProductManagement.vue')
      },
      {
        path: 'catalog-home-banners',
        name: 'CatalogHomeBannerManagement',
        component: () => import('@/views/CatalogHomeBannerManagement.vue')
      },
      {
        path: 'catalog-warehouses',
        name: 'CatalogWarehouseManagement',
        component: () => import('@/views/CatalogWarehouseManagement.vue')
      },
      {
        path: 'catalog-stock-in',
        name: 'CatalogStockInManagement',
        component: () => import('@/views/CatalogStockInManagement.vue')
      },
      {
        path: 'catalog-stock-out',
        name: 'CatalogStockOutManagement',
        component: () => import('@/views/CatalogStockOutManagement.vue')
      },
      {
        path: 'catalog-stock-balances',
        name: 'CatalogStockBalanceManagement',
        component: () => import('@/views/CatalogStockBalanceManagement.vue')
      },
      {
        path: 'catalog-receipts',
        name: 'CatalogReceiptManagement',
        component: () => import('@/views/CatalogReceiptManagement.vue')
      },
      {
        path: 'catalog-loading-fees',
        name: 'CatalogLoadingFeeManagement',
        component: () => import('@/views/CatalogLoadingFeeManagement.vue')
      },
      {
        path: 'catalog-expenses',
        name: 'CatalogExpenseManagement',
        component: () => import('@/views/CatalogExpenseManagement.vue')
      },
      {
        path: 'catalog-costs',
        name: 'CatalogCostManagement',
        component: () => import('@/views/CatalogCostManagement.vue')
      },
      {
        path: 'catalog-employees',
        name: 'CatalogEmployeeManagement',
        component: () => import('@/views/CatalogEmployeeManagement.vue')
      },
      {
        path: 'catalog-wx-users',
        name: 'CatalogWxUserManagement',
        component: () => import('@/views/CatalogWxUserManagement.vue')
      },
      {
        path: 'catalog-mall-orders',
        name: 'CatalogMallOrderManagement',
        component: () => import('@/views/CatalogMallOrderManagement.vue')
      },
      {
        path: 'catalog-employee-salaries',
        name: 'CatalogEmployeeSalaryManagement',
        component: () => import('@/views/CatalogEmployeeSalaryManagement.vue')
      },
      {
        path: 'catalog-employee-rewards',
        name: 'CatalogEmployeeRewardManagement',
        component: () => import('@/views/CatalogEmployeeRewardManagement.vue')
      },
      {
        path: 'catalog-employee-balance-logs',
        name: 'CatalogEmployeeBalanceLogManagement',
        component: () => import('@/views/CatalogEmployeeBalanceLogManagement.vue')
      },
      {
        path: 'catalog-shareholder-settlements',
        name: 'CatalogShareholderSettlementManagement',
        component: () => import('@/views/CatalogShareholderSettlementManagement.vue')
      },
      {
        path: 'catalog-company-info',
        name: 'CatalogCompanyInfoManagement',
        component: () => import('@/views/CatalogCompanyInfoManagement.vue')
      },
      {
        path: 'letterhead-companies',
        name: 'LetterheadCompanyManagement',
        component: () => import('@/views/LetterheadCompanyManagement.vue')
      },
      {
        path: 'seal-generator',
        name: 'SealGeneratorManagement',
        component: () => import('@/views/SealGeneratorManagement.vue')
      },
      {
        path: 'accompanying-documents',
        name: 'AccompanyingDocumentManagement',
        component: () => import('@/views/AccompanyingDocumentManagement.vue')
      },
      {
        path: 'settings/menus',
        name: 'MenuManagement',
        component: () => import('@/views/MenuManagement.vue')
      },
      {
        path: 'settings/users',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement_with_roles.vue')
      },
      {
        path: 'settings/roles',
        name: 'RoleManagement',
        component: () => import('@/views/RoleManagement.vue')
      },
      {
        path: 'settings/qiniu-config',
        name: 'QiniuConfigManagement',
        component: () => import('@/views/QiniuConfigManagement.vue')
      },
      {
        path: 'file-management',
        name: 'FileManagement',
        component: () => import('@/views/FileManagement.vue')
      },
      {
        path: 'finance/customers',
        name: 'FinanceCustomerManagement',
        component: () => import('@/views/finance/FinanceCustomerManagement.vue')
      },
      {
        path: 'finance/accounts',
        name: 'FinanceAccountManagement',
        component: () => import('@/views/finance/FinanceAccountManagement.vue')
      },
      {
        path: 'finance/receipts',
        name: 'FinanceReceiptManagement',
        component: () => import('@/views/finance/FinanceReceiptManagement.vue')
      },
      {
        path: 'finance/expenses',
        name: 'FinanceExpenseManagement',
        component: () => import('@/views/finance/FinanceExpenseManagement.vue')
      },
      {
        path: 'finance/expense-customers',
        name: 'FinanceExpenseCustomerManagement',
        component: () => import('@/views/finance/FinanceExpenseCustomerManagement.vue')
      },
      {
        path: 'contracts',
        name: 'ContractManagement',
        component: () => import('@/views/contract/ContractManagement.vue')
      },
      {
        path: 'labor-fee-receipt',
        name: 'LaborFeeReceipt',
        component: () => import('@/views/LaborFeeReceipt.vue')
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('@/views/UserProfile.vue')
      },
      {
        path: 'project/:projectId',
        name: 'ProjectDetail',
        component: () => import('@/views/ProjectDetail.vue'),
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

  if (requiresAuth) {
    if (token) {
      next()
    } else {
      next('/login')
    }
  } else if (to.path === '/login' && token) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
